import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=6ebda92a&"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports